import { render } from "./admin-recent-project.vue?vue&type=template&id=545b6174"
import script from "./admin-recent-project.vue?vue&type=script&lang=js"
export * from "./admin-recent-project.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__